import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=60f607fe&scoped=true&"
import script from "./NoteModal.vue?vue&type=script&lang=js&"
export * from "./NoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f607fe",
  null
  
)

export default component.exports